/* oxlint-disable @fullscript/gql-file-usage */
import { useMutation, gql, type MutationHookOptions } from "@apollo/client";

import type {
  MerchantDataAddressUpdatePayload,
  MutationMerchantDataAddressUpdateArgs,
} from "@shared/types/graphqlGenerated";

const MerchantDataAddressUpdate_Shared_Mutation = gql`
  mutation MerchantDataAddressUpdate_Shared_Mutation($input: MerchantDataAddressUpdateInput!) {
    merchantDataAddressUpdate(input: $input) {
      merchantData {
        id
        city
        phone
        postalCode
        region
        streetAddress
        streetAddress2
        email
        jobTitle
        isEquityOwner
        businessAddress {
          id
          phone
          address1
          address2
          stateId
          city
          zipcode
        }
      }
      store {
        id
        realMarginType
        directors {
          id
          firstName
          lastName
          email
        }
        equityOwners {
          id
          firstName
          lastName
          city
          region
          streetAddress
          postalCode
          dateOfBirth
        }
      }
      errors {
        message
        fields {
          email
          jobTitle
          city
          phone
          postalCode
          region
          streetAddress
          bankRoutingNumber
          bankAccountNumber
          bankAccountType
          bankAccountHeldBy
          bankAccountHolder
          businessAddress {
            phone
            address1
            state
            city
            zipcode
          }

          directors {
            index
            errors {
              id
              firstName
              lastName
              email
            }
          }

          equityOwners {
            index
            errors {
              id
              firstName
              lastName
              city
              region
              streetAddress
              postalCode
              dateOfBirth
            }
          }
        }
      }
    }
  }
`;

interface MerchantDataAddressUpdateData {
  merchantDataAddressUpdate: MerchantDataAddressUpdatePayload;
}

const useMerchantDataAddressUpdate = (
  options?: MutationHookOptions<
    MerchantDataAddressUpdateData,
    MutationMerchantDataAddressUpdateArgs
  >
) =>
  useMutation<MerchantDataAddressUpdateData, MutationMerchantDataAddressUpdateArgs>(
    MerchantDataAddressUpdate_Shared_Mutation,
    options
  );

/* oxlint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  MerchantDataAddressUpdate_Shared_Mutation,
  useMerchantDataAddressUpdate,
  type MerchantDataAddressUpdateData,
};
